<template>
  <div class="access-message">
    <i class="icofont-warning"></i>
    <h1>Acesso suspenso</h1>
    <p>
      Acesso temporariamente suspenso para o seu município.
    </p>
    <router-link to="/login">Voltar para o início</router-link>
  </div>
</template>

<script>
export default {
  name: 'MunicipioNegado',
  data() {
    return {}
  }
}
</script>

<style>
.access-message {
  background-color: #fff;
  padding: 25px;
  box-shadow: 0 3px 10px rgba(62, 85, 120, 0.045);
  border-radius: 1rem;
  background-color: #fff;
  border: 1px solid #deebfd;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

.access-message i {
  font-size: 80px;
}

.access-message a {
  border: 1px solid;
  padding: 10px 20px;
  border-radius: 50px;
  text-transform: uppercase;
  display: inline-block;
  margin-top: 10px;
  font-size: 20px;
}

/* 
    ##Device = Most of the Smartphones Mobiles (Portrait)
    ##Screen = B/w 320px to 479px
    */

@media (min-width: 320px) and (max-width: 480px) {
  .access-message {
    width: 300px;
  }
  .access-message h1 {
    font-size: 30px;
  }
  .access-message a {
    font-size: 16px;
  }
}

/* 
    ##Device = Tablets, Ipads (portrait)
    ##Screen = B/w 768px to 1024px
    */

@media (min-width: 768px) and (max-width: 1024px) {
  .access-message {
    width: 500px;
  }
}
</style>
